/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-use-before-define */
/* eslint-disable no-alert */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-return-assign */
/* eslint-disable no-console */
import { AccountInfo, Network, NetworkType, SigningType, RequestSignPayloadInput } from '@airgap/beacon-sdk';
import { BeaconWallet } from '@taquito/beacon-wallet';
import { TezosToolkit, MichelsonMap, OpKind, WalletParamsWithKind } from '@taquito/taquito';
import { char2Bytes, bytes2Char } from '@taquito/utils';
import { signIn, signOut } from 'next-auth/react';
import { Platforms, INITIAL_RANDOM_NODE, BURN_ADDRESS } from '@constants';
import { ILooseObject } from '@interface/loose-object';
import { TezToMut } from '@utils/format';
import { testNodeHealth } from '@utils/node';
import { handleError } from './error';
import { log } from './plausible';

// versum
const CONTRACT_MATERIA: string = process.env.CONTRACT_MATERIA!; // https://better-call.dev/hangzhou2net/KT19H5n7aydmaNpChwohGFyswTSQZYsnuPPi/interact?entrypoint=claim_materia
const CONTRACT_IDENTITY: string = process.env.CONTRACT_IDENTITY!; // https://better-call.dev/hangzhou2net/KT1QkEJHHCpkx2UKvC7fL6tQquZhvRthoYpH/interact?entrypoint=claim_username
const CONTRACT_TOKENS: string = process.env.CONTRACT_TOKENS!;
const CONTRACT_MARKET: string = process.env.CONTRACT_MARKET!; // https://better-call.dev/hangzhou2net/KT1UMUL2Rne9YdsA6z7WJmwT2S1P5pKPPQSx/interact?entrypoint=collect_swap

// tezos.domains
const CONTRACT_TEZOS_DOMAINS: string = process.env.CONTRACT_TEZOS_DOMAINS!;

let wallet: BeaconWallet;
let tezos: TezosToolkit;
let network: Network;

// -------------------------------------------------------
// Utils
// -------------------------------------------------------
const toHEX = (ipfs: string) => {
  return `ipfs://${ipfs}`.split('').reduce((hex, c) => (hex += c.charCodeAt(0).toString(16).padStart(2, '0')), '');
};

// -------------------------------------------------------
// Beacon
// -------------------------------------------------------
export const initBeacon = () => {
  network = {
    type: process.env.LOGGEDOUT_TEZOS_NETWORK as NetworkType,
    name: process.env.LOGGEDOUT_TEZOS_NETWORK,
    rpcUrl: INITIAL_RANDOM_NODE.value,
  };

  if (!wallet && !tezos) {
    wallet = new BeaconWallet({ name: 'versum', preferredNetwork: network.type });

    tezos = new TezosToolkit(network.rpcUrl as string);
    tezos.setWalletProvider(wallet);
  }
};

export const changeBeacon = (nextNetwork: string, nextRpcValue: string) => {
  if (nextNetwork !== network.type && nextRpcValue !== network.rpcUrl) {
    network = {
      type: nextNetwork as NetworkType,
      name: nextNetwork,
      rpcUrl: nextRpcValue,
    };

    wallet.client.preferredNetwork = nextNetwork as NetworkType;
    wallet.client.clearActiveAccount();
    wallet.client.requestPermissions({ network });

    tezos = new TezosToolkit(network.rpcUrl as string);
    tezos.setWalletProvider(wallet);
  }

  if (nextNetwork === network.type && nextRpcValue !== network.rpcUrl) {
    network = {
      type: nextNetwork as NetworkType,
      name: nextNetwork,
      rpcUrl: nextRpcValue,
    };

    tezos = new TezosToolkit(network.rpcUrl as string);
    tezos.setWalletProvider(wallet);
  }
};

export const getActiveAccount = async (): Promise<AccountInfo | undefined> => {
  try {
    return await wallet.client.getActiveAccount();
  } catch (error) {
    handleError('Beacon SDK failed', error);
    return undefined;
  }
};

export const getMichelineStringBytes = (str: string) => {
  const convertedBytes = char2Bytes(str);
  const strLength = (convertedBytes.length / 2).toString(16).padStart(8, '0');
  return `0501${strLength}${convertedBytes}`;
};

export const login = async (): Promise<AccountInfo | undefined> => {
  await wallet.client.requestPermissions({ network });

  const accInfo = await wallet.client.getActiveAccount();
  const timestamp = Date.now();
  const signinData = `Tezos Signed Message: Versum Login for ${accInfo?.address} at ${new Date(
    timestamp
  ).toISOString()}.`;

  const data = getMichelineStringBytes(signinData);

  const payload: RequestSignPayloadInput = {
    signingType: SigningType.MICHELINE,
    payload: data,
    sourceAddress: accInfo?.address,
  };
  const { signature } = await wallet.client.requestSignPayload(payload);
  const response = await signIn('credentials', {
    redirect: false,
    wallet: accInfo?.address,
    signed_data: data,
    signature,
    public_key: accInfo?.publicKey,
  });

  if (response) {
    const { ok, error } = response;
    if (ok && !error) {
      return accInfo;
    }
  }
  await wallet.clearActiveAccount();
  return undefined;
};

export const logout = async (): Promise<void> => {
  return signOut({ callbackUrl: process.env.NEXTAUTH_URL }).then(() => {
    wallet.clearActiveAccount();
  });
};

// -------------------------------------------------------
// UTILS
// -------------------------------------------------------
export const getTezDomainFromTezAddress = async (address = 'tz1eht4WAjkqU7kaupJd8qCDmec9HuKfGf68') => {
  const Tezos = new TezosToolkit('https://mainnet.api.tez.ie');
  const contract = await Tezos.wallet.at(CONTRACT_TEZOS_DOMAINS);
  const storage: any = await contract.storage();
  const domain = await storage.store.reverse_records.get(address);

  if (domain) {
    return bytes2Char(domain.name);
  }
  return address;
};

export const getTezAddressFromTezDomain = async (domainName = 'andrevenancio.tez') => {
  const Tezos = new TezosToolkit('https://mainnet.api.tez.ie');
  const contract = await Tezos.wallet.at(CONTRACT_TEZOS_DOMAINS);
  const storage: any = await contract.storage();
  const domain = await storage.store.records.get(char2Bytes(domainName));

  if (domain) {
    return domain.owner;
  }

  return domainName;
};

// -------------------------------------------------------
// MINT
// -------------------------------------------------------
export const mint = async (props: ILooseObject): Promise<any> => {
  // calculate no transfers until
  const parts = props.lock.data.split('-');
  const noTransfersUntil = new Date(parts[0], parts[1] - 1, parts[2]);

  const amount = props.editions.data;
  const infusions: never[] = [];
  const max_per_address = props.limit.data;
  const metadata = MichelsonMap.fromLiteral({ '': toHEX(props.metadataHash) });
  const no_transfers_until = props.lock.data ? noTransfersUntil : null; // timestamp 'None'
  const req_verified_to_own = props.verified.data || false; // confirm
  const royalties = String(props.royalties.data);
  const splits = props.splits.data.map((current: Record<string, any>) => {
    return { address: current.address, pct: String(current.pct * 10) };
  });

  // check contract based on network
  const contract = await tezos.wallet.at(CONTRACT_TOKENS);

  const result = await contract.methods
    .mint(amount, infusions, max_per_address, metadata, no_transfers_until, req_verified_to_own, royalties, splits)
    .send({ amount: 0, storageLimit: 1000 })
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('mint', { amount, infusions, max_per_address, req_verified_to_own, royalties });
    })
    .catch((error) => {
      handleError(
        'Error signing transaction on mint',
        {
          props: {
            amount,
            infusions,
            max_per_address,
            metadata,
            no_transfers_until,
            req_verified_to_own,
            royalties,
            splits,
          },
          send: { amount: 0, storageLimit: 1000 },
          error,
        },
        () => {
          window.location.href = '/mint';
        }
      );
    });

  return result;
};

// -------------------------------------------------------
// BURN
// -------------------------------------------------------
export const burn = async (from: string, amount: number, _platform: string, tokenKT: string, token_id: number) => {
  // README:
  // burning is deprecated until Dipdup fixes a bug (info from Veqtor).
  // if (platform === Platforms.VERSUM) {
  //   // check contract based on network
  //   const contract = await tezos.wallet.at(tokenKT);
  //   const result = await contract.methods.burn(from, amount, token_id).send({ amount: 0 /* , storageLimit: 250 */ });

  //   return result;
  // }

  // any other platforms just send token to burn address
  const contract = await tezos.wallet.at(tokenKT);
  const result = await contract.methods
    .transfer([
      {
        from_: from,
        txs: [
          {
            to_: BURN_ADDRESS,
            token_id,
            amount,
          },
        ],
      },
    ])
    .send()
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('transfer', { amount });
    })
    .catch((error) => {
      handleError('Error on transfer', {
        props: { from, to: BURN_ADDRESS, amount, tokenKT, token_id },
        send: {},
        error,
      });
    });

  return result;
};

// -------------------------------------------------------
// TRANSFER
// -------------------------------------------------------
export const transfer = async (from: string, to: any[], _platformName: string, tokenKT: string, token_id: number) => {
  const contract = await tezos.wallet.at(tokenKT);
  const result = await contract.methods
    .transfer([
      {
        from_: from,
        // txs: [
        //   {
        //     to_: to,
        //     token_id,
        //     amount,
        //   },
        // ],
        txs: to.map((tx: any) => {
          return {
            to_: tx.wallet,
            token_id,
            amount: tx.quantity,
          };
        }),
      },
    ])
    .send()
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('transfer', { token_id });
    })
    .catch((error) => {
      handleError('Error on transfer', { props: { from, to, tokenKT, token_id }, send: {}, error });
    });

  return result;
};

// -------------------------------------------------------
// SWAPS
// -------------------------------------------------------
export const swapCreate = async (
  burnOnEnd: boolean,
  maxPerTransaction: number,
  startingPrice: number,
  endingPrice: number,
  quantity: number,
  duration: number | null,
  platform: string,
  tokenKT: string,
  tokenId: number,
  creatorsTotal = 1
) => {
  const now = new Date();

  const contract = await tezos.wallet.at(CONTRACT_MARKET);

  const burn_on_end = burnOnEnd;
  const collect_max_per_tx = maxPerTransaction;
  const currency = null; // option [currencyKT, currencyId]
  const ending_price_in_nat = endingPrice;
  const ending_time = duration !== null ? new Date(now.getTime() + duration * 60 * 60 * 1000) : null; // false;
  const require_verified = false;
  const starting_price_in_nat = startingPrice;
  const token = [tokenKT, tokenId];
  const token_amount = quantity;
  const storageLimit = 175 + (150 + 100 * creatorsTotal) + 175;

  if (platform === Platforms.VERSUM) {
    return contract.methods
      .create_swap(
        burn_on_end,
        collect_max_per_tx,
        currency,
        ending_price_in_nat,
        ending_time,
        require_verified,
        starting_price_in_nat,
        ...token,
        token_amount
      )
      .send({ amount: 0, storageLimit: 150 + 100 * creatorsTotal })
      .then((op: any) => op.confirmation().then(() => op.opHash))
      .then(() => {
        log('create_swap', {
          burn_on_end,
          collect_max_per_tx,
          currency,
          ending_price_in_nat,
          starting_price_in_nat,
          token_amount,
        });
      })
      .catch((error) => {
        handleError('Error on create_swap', {
          props: {
            burn_on_end,
            collect_max_per_tx,
            currency,
            ending_price_in_nat,
            ending_time,
            require_verified,
            starting_price_in_nat,
            ...token,
            token_amount,
          },
          send: { amount: 0, storageLimit },
          error,
        });
      });
  }

  // NON VERSUM
  const userwallet = await wallet.getPKH();
  const original = await tezos.wallet.at(tokenKT);

  const list: WalletParamsWithKind[] = [
    {
      kind: OpKind.TRANSACTION,
      ...original.methods
        .update_operators([{ add_operator: { owner: userwallet, operator: CONTRACT_MARKET, token_id: tokenId } }])
        .toTransferParams({ amount: 0, mutez: true, storageLimit: 175 }),
    },
    {
      kind: OpKind.TRANSACTION,
      ...contract.methods
        .create_swap(
          burn_on_end,
          collect_max_per_tx,
          currency,
          ending_price_in_nat,
          ending_time,
          require_verified,
          starting_price_in_nat,
          ...token,
          token_amount
        )
        .toTransferParams({ amount: 0, mutez: true, storageLimit: 150 + 100 * creatorsTotal }),
    },
    {
      kind: OpKind.TRANSACTION,
      ...original.methods
        .update_operators([{ remove_operator: { owner: userwallet, operator: CONTRACT_MARKET, token_id: tokenId } }])
        .toTransferParams({ amount: 0, mutez: true, storageLimit: 175 }),
    },
  ];

  const batch = await tezos.wallet.batch(list);

  return batch
    .send()
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('create_swap', {
        burn_on_end,
        collect_max_per_tx,
        currency,
        ending_price_in_nat,
        starting_price_in_nat,
        token_amount,
      });
    })
    .catch((error) => {
      handleError('Error on create_swap', {
        props: {
          burn_on_end,
          collect_max_per_tx,
          currency,
          ending_price_in_nat,
          ending_time,
          require_verified,
          starting_price_in_nat,
          ...token,
          token_amount,
        },
        send: { amount: 0, storageLimit: 150 + 100 * creatorsTotal },
        error,
      });
    });
};

export const swapCancel = async (swap_id: number) => {
  const contract = await tezos.wallet.at(CONTRACT_MARKET);
  const result = await contract.methods
    .cancel_swap(swap_id)
    .send({ amount: 0, mutez: true, storageLimit: 250 })
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('swap_cancel', {});
    })
    .catch((error) => {
      handleError('Error on cancel_swap', {
        props: { swap_id },
        send: { amount: 0, mutez: true, storageLimit: 250 },
        error,
      });
    });

  return result;
};

// TODO: missing log and error on batch operation
export const swapCancelBatch = async (swap_ids: number[]) => {
  const contract = await tezos.wallet.at(CONTRACT_MARKET);

  const list: WalletParamsWithKind[] = [];
  for (let i = 0; i < swap_ids.length; i += 1) {
    list.push({
      kind: OpKind.TRANSACTION,
      ...contract.methods.cancel_swap(swap_ids[i]).toTransferParams({
        amount: 0,
        mutez: true,
        storageLimit: 250,
      }),
    });
  }
  const batch = await tezos.wallet.batch(list);
  const batchOp = await batch.send();
  const result = await batchOp.confirmation();
  return result;
};

export const swapCollect = async (swap_id: number, amount_mutez: number, amount: number, creatorsTotal = 1) => {
  const contract = await tezos.wallet.at(CONTRACT_MARKET);
  const alive = await testNodeHealth(`${network.rpcUrl}/chains/main/blocks/head/hash`);
  console.log('alive', network.rpcUrl, alive);

  const params = { amount: amount_mutez, mutez: true, storageLimit: 150 + 100 * creatorsTotal, gasLimit: 200000 };
  const result = await contract.methods
    .collect_swap(amount, swap_id)
    .send(params)
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('collect_swap', params);
    })
    .catch((error) => {
      handleError('Error on collect_swap', {
        props: { amount, swap_id },
        send: params,
        error,
      });
    });

  return result;
};

// -------------------------------------------------------
// AUCTION
// -------------------------------------------------------
export const auctionCreate = async (
  startPrice: number,
  duration: number,
  tokenKT: string,
  tokenId: number,
  platform: string
) => {
  const now = new Date();

  const bid_amount = startPrice; // Starting price in nat
  const currency = null; // [currencyKT, currencyId]
  const end_timestamp = new Date(now.getTime() + duration * 60 * 60 * 1000); // false;
  const require_verified = false;
  const token = [tokenKT, tokenId];
  const token_amount = 1;

  const contract = await tezos.wallet.at(CONTRACT_MARKET);

  if (platform === Platforms.VERSUM) {
    const result = await contract.methods
      .create_auction(bid_amount, currency, end_timestamp, require_verified, ...token, token_amount)
      .send({ amount: 0, storageLimit: 250 })
      .then((op: any) => op.confirmation().then(() => op.opHash))
      .then(() => {
        log('create_auction', { startPrice, duration });
      })
      .catch((error) => {
        handleError('Error on create_auction', {
          props: { bid_amount, currency, end_timestamp, require_verified, ...token, token_amount },
          send: { amount: 0, storageLimit: 250 },
          error,
        });
      });

    return result;
  }

  // NON VERSUM
  const userwallet = await wallet.getPKH();
  const original = await tezos.wallet.at(tokenKT);

  const list: WalletParamsWithKind[] = [
    {
      kind: OpKind.TRANSACTION,
      ...original.methods
        .update_operators([{ add_operator: { owner: userwallet, operator: CONTRACT_MARKET, token_id: tokenId } }])
        .toTransferParams({ amount: 0, mutez: true, storageLimit: 175 }),
    },
    {
      kind: OpKind.TRANSACTION,
      ...contract.methods
        .create_auction(bid_amount, currency, end_timestamp, require_verified, ...token, token_amount)
        .toTransferParams({ amount: 0, storageLimit: 250 }),
    },
    {
      kind: OpKind.TRANSACTION,
      ...original.methods
        .update_operators([{ remove_operator: { owner: userwallet, operator: CONTRACT_MARKET, token_id: tokenId } }])
        .toTransferParams({ amount: 0, mutez: true, storageLimit: 175 }),
    },
  ];

  const batch = await tezos.wallet.batch(list);

  return batch
    .send()
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('create_auction', { startPrice, duration });
    })
    .catch((error) => {
      handleError('Error on create_auction', {
        props: { bid_amount, currency, end_timestamp, require_verified, ...token, token_amount },
        send: { amount: 0, storageLimit: 250 },
        error,
      });
    });
};

export const auctionBid = async (auction_id: number, bid_amount_tez: number) => {
  const bid_amount_fa2 = 0;

  const contract = await tezos.wallet.at(CONTRACT_MARKET);

  const result = await contract.methods
    .bid(auction_id, bid_amount_fa2)
    .send({ amount: TezToMut(bid_amount_tez), mutez: true, storageLimit: 250 })
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('bid', { bid_amount_tez });
    })
    .catch((error) => {
      handleError('Error on bid', {
        props: { auction_id, bid_amount_fa2 },
        send: { amount: TezToMut(bid_amount_tez), mutez: true, storageLimit: 250 },
        error,
      });
    });

  return result;
};

export const auctionWithdraw = async (auction_id: number) => {
  const contract = await tezos.wallet.at(CONTRACT_MARKET);

  const result = await contract.methods
    .withdraw(auction_id)
    .send({ amount: 0, storageLimit: 250 })
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('withdraw', {});
    })
    .catch((error) => {
      handleError('Error on withdraw', { props: { auction_id }, send: { amount: 0, storageLimit: 250 }, error });
    });

  return result;
};

// -------------------------------------------------------
// OFFERS
// -------------------------------------------------------

/*
You can create an offer as XTZ or FA2.
*/
export const offerCreate = async (price: number, quantity: number, tokenKT: string, tokenId: number) => {
  let price_in_mutez = TezToMut(price);
  let price_in_nat = 0;

  const currency = null; // [currencyKT, currencyId]
  if (currency) {
    price_in_mutez = 0;
    price_in_nat = TezToMut(price);
  }
  const token = [tokenKT, tokenId];
  const token_amount = quantity;
  const require_verified = false;

  const contract = await tezos.wallet.at(CONTRACT_MARKET);

  const result = await contract.methods
    .make_offer(currency, price_in_nat, require_verified, ...token, token_amount)
    .send({ amount: price_in_mutez, mutez: true, storageLimit: 250 })
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('make_offer', { price, require_verified, token_amount });
    })
    .catch((error) => {
      handleError('Error on make_offer', {
        props: { currency, price_in_nat, require_verified, ...token, token_amount },
        send: { amount: price_in_mutez, mutez: true, storageLimit: 250 },
        error,
      });
    });

  return result;
};

export const offerCancel = async (offer_id: number) => {
  const contract = await tezos.wallet.at(CONTRACT_MARKET);

  const result = await contract.methods
    .cancel_offer(offer_id)
    .send({ amount: 0, storageLimit: 250 })
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('cancel_offer', {});
    })
    .catch((error) => {
      handleError('Error on cancel_offer', { props: { offer_id }, send: { amount: 0, storageLimit: 250 }, error });
    });

  return result;
};

// TODO: add logs and errors
export const offerCancelBatch = async (offer_ids: number[]) => {
  const contract = await tezos.wallet.at(CONTRACT_MARKET);

  const list: WalletParamsWithKind[] = [];
  for (let i = 0; i < offer_ids.length; i += 1) {
    list.push({
      kind: OpKind.TRANSACTION,
      ...contract.methods.cancel_offer(offer_ids[i]).toTransferParams({
        amount: 0,
        mutez: true,
        storageLimit: 250,
      }),
    });
  }
  const batch = await tezos.wallet.batch(list);
  const batchOp = await batch.send();
  const result = await batchOp.confirmation();
  return result;
};

export const offerAccept = async (offer_id: number, tokenKT: string, tokenId: number, platform: string) => {
  const contract = await tezos.wallet.at(CONTRACT_MARKET);

  if (platform === Platforms.VERSUM) {
    const result = await contract.methods
      .accept_offer(offer_id)
      .send({ amount: 0, storageLimit: 250 })
      .then((op: any) => op.confirmation().then(() => op.opHash))
      .then(() => {
        log('accept_offer', {});
      })
      .catch((error) => {
        handleError('Error on accept_offer', { props: { offer_id }, send: { amount: 0, storageLimit: 250 }, error });
      });
    return result;
  }

  // NON VERSUM
  const userwallet = await wallet.getPKH();
  const original = await tezos.wallet.at(tokenKT);

  const list: WalletParamsWithKind[] = [
    {
      kind: OpKind.TRANSACTION,
      ...original.methods
        .update_operators([{ add_operator: { owner: userwallet, operator: CONTRACT_MARKET, token_id: tokenId } }])
        .toTransferParams({ amount: 0, mutez: true, storageLimit: 175 }),
    },
    {
      kind: OpKind.TRANSACTION,
      ...contract.methods.accept_offer(offer_id).toTransferParams({ amount: 0, storageLimit: 250 }),
    },
    {
      kind: OpKind.TRANSACTION,
      ...original.methods
        .update_operators([{ remove_operator: { owner: userwallet, operator: CONTRACT_MARKET, token_id: tokenId } }])
        .toTransferParams({ amount: 0, mutez: true, storageLimit: 175 }),
    },
  ];

  const batch = await tezos.wallet.batch(list);

  return batch
    .send()
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('accept_offer', {});
    })
    .catch((error) => {
      handleError('Error on accept_offer', { props: { offer_id }, send: { amount: 0, storageLimit: 250 }, error });
    });
};

// -------------------------------------------------------
// COLLABORATIONS (versum items only)
// -------------------------------------------------------
export const acceptCollaboration = async (tokenId: number) => {
  const contract = await tezos.wallet.at(CONTRACT_TOKENS);

  const result = await contract.methods
    .sign_cocreator(tokenId)
    .send({ amount: 0, storageLimit: 250 })
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('sign_cocreator', {});
    })
    .catch((error) => {
      handleError('Error on sign_cocreator', { props: { tokenId }, send: { amount: 0, storageLimit: 250 }, error });
    });

  return result;
};

// -------------------------------------------------------
// CLAIMS
// -------------------------------------------------------
export const claimMateria = async (amount: number, proofs: string[]) => {
  const contract = await tezos.wallet.at(CONTRACT_MATERIA);

  const result = await contract.methods
    .claim_materia(amount, proofs)
    .send({ amount: 0, storageLimit: 250 })
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('claim_materia', { amount });
    })
    .catch((error) => {
      handleError('Error on claim_materia', {
        props: { amount, proofs },
        send: { amount: 0, storageLimit: 250 },
        error,
      });
    });

  return result;
};

export const claimVerification = async (proofs: string[]) => {
  const contract = await tezos.wallet.at(CONTRACT_IDENTITY);

  const result = await contract.methods
    .claim_verification(proofs)
    .send({ amount: 0, storageLimit: 250 })
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('claim_verification', {});
    })
    .catch((error) => {
      handleError('Error on claim_verification', { props: { proofs }, send: { amount: 0, storageLimit: 250 }, error });
    });

  return result;
};

export const claimEscrow = async (userwallet: string) => {
  const contract = await tezos.wallet.at(CONTRACT_IDENTITY);

  const result = await contract.methods
    .withdraw_outstanding_tez(userwallet)
    .send({ amount: 0, storageLimit: 250 })
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('withdraw_outstanding_tez', {});
    })
    .catch((error) => {
      handleError('Error on withdraw_outstanding_tez', {
        props: { userwallet },
        send: { amount: 0, storageLimit: 250 },
        error,
      });
    });

  return result;
};

export const claimKYCcheck = async (userwallet: string) => {
  const contract = await tezos.wallet.at(CONTRACT_IDENTITY);

  const result = await contract.methods
    .claim_kyc_check(userwallet)
    .send({ amount: 0, storageLimit: 250 })
    .then((op: any) => op.confirmation().then(() => op.opHash))
    .then(() => {
      log('claim_kyc_check', {});
    })
    .catch((error) => {
      handleError('Error on claim_kyc_check', { props: { userwallet }, send: { amount: 0, storageLimit: 250 }, error });
    });

  return result;
};

// -------------------------------------------------------
// Display
// -------------------------------------------------------
export const getUserTezos = async (userWallet: string) => {
  return tezos.tz
    .getBalance(userWallet)
    .then((balance) => {
      return { tezos: balance.toNumber() };
    })
    .catch((error) => {
      handleError('Error getting balance', { props: { userWallet }, send: {}, error });
      return { tezos: 0 };
    });
};
